module.exports = __webpack_public_path__ + "static/media/default.75466429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/default.jpg
// module id = 512
// module chunks = 10